var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M19.8555 6.41L18.4455 5L12.8555 10.59L7.26547 5L5.85547 6.41L11.4455 12L5.85547 17.59L7.26547 19L12.8555 13.41L18.4455 19L19.8555 17.59L14.2655 12L19.8555 6.41Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
